<template>
  <div>
    <vx-card
      v-if="$route.name === 'daily-closing-salesman'"
      title="Approval Daily Closing Exception Salesman"
    >
      <div class="mt-3 ml-1 vx-row">
        <vs-tabs>
          <vs-tab label="Open">
            <tab-open></tab-open>
          </vs-tab>
           <vs-tab label="Approved">
              <tab-approved></tab-approved>
          </vs-tab>
          <vs-tab label="Rejected">
              <tab-rejected></tab-rejected>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
    <router-view v-else />
  </div>
</template>
<script>
import TabOpen from "./TabOpen.vue";
import TabApproved from "./TabApproved.vue";
import TabRejected from "./TabRejected.vue";

export default {
  components: {
    TabOpen,
    TabApproved,
    TabRejected,
  },
  data() {
    return {
      activeTab: 0,
      draw: 0
    }
  },
  methods: {
    handleFilter() {
      this.draw++;
    },
    // goIterWarehouse() {
    //   this.$router.push({
    //     name: this.$store.state.inbound.interWarehouse.baseRouterName,
    //   });
    // },
    // goPurchaseOrder() {
    //   this.$router.push({
    //     name: this.$store.state.inbound.purchaseOrder.baseRouterName,
    //   });
    // },
    // goPodReturn() {
    //   this.$router.push({
    //     name: this.$store.state.inbound.podReturn.baseRouterName,
    //   });
    // },
  }
}
</script>
